import Figure from "~/components/figure"
import Circuit from "~/components/circuit"

export default class Pathways extends Component {
  render() {
    return (
      <Surface gridColumn="screen" alignItems="center">
        <Surface
          justifyContent="space-between"
          alignSelf="center"
          flexFlow="row"
        >
          <Circuit
            circuitProps={{ moduleWidth: "auto" }}
            inlineLayerNames
            circuit={[
              {
                name: "mixed3b",
                modules: [
                  {
                    name: "Left",
                    neurons: [333],
                  },
                ],
              },
              {
                name: "mixed4a",
                modules: [
                  {
                    name: "Left",
                    neurons: [222, 325],
                  },
                  {
                    name: "Right",
                    neurons: [308, 234],
                  },
                ],
              },
            ]}
          />

          <Circuit
            circuitProps={{ moduleWidth: "auto" }}
            inlineLayerNames
            circuit={[
              {
                name: "mixed3b",
                modules: [
                  {
                    name: "Right",
                    neurons: [404],
                  },
                ],
              },
              {
                name: "mixed4a",
                modules: [
                  {
                    name: "Left",
                    neurons: [222, 325],
                  },
                  {
                    name: "Right",
                    neurons: [308, 234],
                  },
                ],
              },
            ]}
          />
        </Surface>
      </Surface>
    )
  }
}
